import React, { Component } from 'react';

import SidebarRelationships from './SidebarRelationships';
import Element from '../Element';
import Relationship from './Relationship';
import MultiElementEdit from './MultiElementEdit';

export default class RightColumn extends Component {
  render() {
    const {
      entity,
      callback,
      entityType,
      columnSize,
      options,
      flexOverride,
      dashboard,
      leftBorder,
      optionalCallback,
    } = this.props;

    if (entity.size === 0) {
      return <div>empty</div>;
    }

    let component;

    switch (entityType) {
      case 'wbs':
        component = (
          <Element
            currentElementId={entity}
            selectElement={callback}
            optionalCallback={optionalCallback}
          />
        );
        break;
      case 'element':
        component = (
          <Element
            currentElementId={entity.get('id')}
            selectElement={callback}
            optionalCallback={optionalCallback}
          />
        );
        break;
      case 'singleRelationship':
        component = (
          <Relationship
            relationship={entity.first()}
            selectElement={callback}
            closeRelationshipPanel={options.closeRelationshipPanel}
            clearPartitions={options.clearPartitions}
          />
        );
        break;
      case 'relationship':
        component = (
          <SidebarRelationships
            relationships={entity}
            selectElement={callback}
            closeRelationshipPanel={options.closeRelationshipPanel}
          />
        );
        break;
      case 'multiEdit':
        component = (
          <MultiElementEdit
            elementIds={entity}
            elementType={options.elementType}
            callback={callback}
          />
        );
        break;
      default:
        component = <div />;
        break;
    }

    if (flexOverride && dashboard) {
      return (
        <div style={{ flex: '1', background: '#fff', borderLeft: leftBorder ? '1px solid #ddd' : 0 }}>
          {component}
        </div>
      );
    } else if (flexOverride) {
      return (
        <div style={{ flex: '.5', padding: 10, display: 'flex', borderLeft: leftBorder ? '1px solid #ddd' : 0 }}>
          <div style={{ background: '#fff', flex: 1 }}>
            {component}
          </div>
        </div>
      );
    }

    return (
      <div className={columnSize} style={{ display: 'flex', padding: 10, borderLeft: leftBorder ? '1px solid #ddd' : 0 }}>
        <div style={{ flex: 1, background: '#fff', overflowY: 'auto' }} className="element-pane">
          {component}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RightColumn/RightColumn.js